import { type PublicGlobalConfig } from '../../global-config/config-types/PublicGlobalConfig'
import { experimentsTrackEvent } from '../eventTracking/experimentsTrackEvent'
import { type ExperimentType } from '../model/Experiment.types'

import { experimentsAlgoliaCompeteraExperimentIsEnabled } from './experimentsAlgoliaCompeteraExperiment'

export const experimentsAlgoliaCompeteraTrackCompeteraEvent = (
  experiments: ExperimentType[],
  globalConfig: PublicGlobalConfig,
  eventName: string,
): void => {
  if (experimentsAlgoliaCompeteraExperimentIsEnabled(experiments)) {
    experimentsTrackEvent(globalConfig, eventName)
  }
}
